import React, { Suspense } from 'react';
import useFetchMyAnalytics from '../../../hooks/me/useFetchMyAnalytics';
import { formatPrice, formatTime } from '../../../utils/formatter';
import CommonLoader from '../../shared/loaders/CommonLoader';
import AnalyticCharts from './AnalyticChart';
import AnalyticWidget from './AnalyticWidget';

function MyAnalytics() {
  const { loading, analytics } = useFetchMyAnalytics();

  return (
    <Suspense fallback={<CommonLoader />}>
      {!loading && (
        <div className="grid gap-4">
          <div className="grid lg:grid-cols-4 grid-cols-2 gap-3 lg:gap-4">
            <AnalyticWidget
              title="Дохід"
              loading={loading}
              monthTotal={formatPrice(analytics.totalTasksIncome?.monthTotal || 0)}
              total={formatPrice(analytics.totalTasksIncome?.fullTotal || 0)}
              percent={analytics.totalTasksIncome?.lastMonthPercentChange || 0}
            />
            <AnalyticWidget
              title="Години"
              loading={loading}
              monthTotal={formatTime(analytics.totalHours?.monthTotal || 0)}
              total={formatTime(analytics.totalHours?.fullTotal || 0)}
              percent={analytics.totalHours?.lastMonthPercentChange || 0}
            />
            <AnalyticWidget
              title="Візитів"
              loading={loading}
              monthTotal={analytics.totalVisits?.monthTotal || 0}
              total={analytics.totalVisits?.fullTotal || 0}
              percent={analytics.totalVisits?.lastMonthPercentChange || 0}
            />
            <AnalyticWidget
              title="Автомобілів"
              loading={loading}
              monthTotal={analytics.totalVehicles?.monthTotal || 0}
              total={analytics.totalVehicles?.fullTotal || 0}
              percent={analytics.totalVehicles?.lastMonthPercentChange || 0}
            />
          </div>
          {analytics.tasksIncomePerMonth?.length ? <AnalyticCharts data={analytics.tasksIncomePerMonth} /> : null}
        </div>
      )}
    </Suspense>
  );
}

export default MyAnalytics;
